import { List, Map } from 'immutable'
import React from 'react'
import { Form } from 'semantic-ui-react'
import Buttons from './Buttons'
import Checkbox from './Checkbox'
import Checkboxes from './Checkboxes'
import Color from './Color'
import Config from './Config'
import ContentField from './Content'
import CourseSteps from './CourseSteps'
import DateField from './Date'
import DateTimeField from './DateTime'
import File from './File'
import FileUrl from './FileUrl'
import Icon from './Icon'
import Image from './Image'
import Industry from './Industry'
import Input from './Input'
import Links from './Links'
import Machine from './Machine'
import MapField from './Map'
import Radios from './Radios'
import Range from './Range'
import Reference from './Reference'
import Select from './Select'
import Tasks from './Tasks'
import Templates from './Templates'
import Textarea from './Textarea'
import TranslatableTextArea from './TranslatableTextArea'
import TranslatableTextField from './TranslatableTextField'
import Wysiwyg from './Wysiwyg'

let inputs = {
  password: Input,
  email: Input,
  text: Input,
  number: Input,
  textarea: Textarea,
  checkbox: Checkbox,
  radios: Radios,
  color: Color,
  image: Image,
  buttons: Buttons,
  checkboxes: Checkboxes,
  reference: Reference,
  industry: Industry,
  wysiwyg: Wysiwyg,
  range: Range,
  date: DateField,
  datetime: DateTimeField,
  select: Select,
  icon: Icon,
  tasks: Tasks,
  machine: Machine,
  templates: Templates,
  translatable: TranslatableTextField,
  translatableTextField: TranslatableTextField,
  translatableTextArea: TranslatableTextArea,
  links: Links,
  config: Config,
  file: File,
  fileUrl: FileUrl,
  courseSteps: CourseSteps,
  map: MapField,
  content: ContentField,
}

export default function FormField(props) {
  let {
    label = false,
    description = false,
    inputLabel = false,
    tags = [],
    options = [],
    type = false,
    disabled = false,
    id = false,
    name,
    formState = {},
    value,
    ...passProps
  } = props

  let { values = Map(), errors = Map() } = formState

  let fieldErrors = errors.get(name, false)
  value = value === undefined ? values.getIn(name.split('.'), null) : value

  if (type === 'textfield') type = 'text'

  if (value === null) value = ''

  // if (['checkbox', 'color', 'image'].indexOf(type) > -1)
  //   label = inputLabel

  let inputProps = {
    ...passProps,
    id: id || name,
    name,
    type,
    inputLabel,
    value,
    disabled,
    formState,
    tags,
    options,
  }

  let input = inputs[type] ? (
    React.createElement(inputs[type], inputProps)
  ) : (
    <div className="form-field-unknown">{`No type found for ${type}`}</div>
  )

  return (
    <Form.Field className="form-field">
      {label ? <label htmlFor={id || name}>{label}</label> : null}
      {input}
      {List.isList(fieldErrors) ? (
        <div className="field-errors">
          {fieldErrors.map((error, key) => (
            <div className="field-error" key={key}>
              {error}
            </div>
          ))}
        </div>
      ) : null}
      {description ? <div className="form-description">{description}</div> : null}
    </Form.Field>
  )
}
